const ROLE_ADMINISTRATOR_ID = 14;
const ROLE_PROVIDER_ID = 15;
const ROLE_RESELLER_ID = 3;
const ROLE_SUPPORT_ID = 4;

const roles = {};

roles[ROLE_ADMINISTRATOR_ID] = 'administrator';
roles[ROLE_PROVIDER_ID] = 'provider';
roles[ROLE_RESELLER_ID] = 'reseller';
roles[ROLE_SUPPORT_ID] = 'support';

const get = (value) => {
    return roles[value];
};

const exists = (value) => {
    return !!roles[value];
};

export default {
    exists: (value) => {
        return !!roles[value];
    },
    getRole: (value) => {
        if (!exists(value)) {
            return;
        }

        return get(value);
    },
    getAdministratorRoleId: () => {
        return ROLE_ADMINISTRATOR_ID;
    },
    getProviderRoleId: () => {
        return ROLE_PROVIDER_ID;
    },
    getResellerRoleId: () => {
        return ROLE_RESELLER_ID;
    },
};



// WEBPACK FOOTER //
// ./src/helpers/roles.js